export const ADD_INGREDIENTS = "ADD_INGREDIENTS"
export const REMOVE_INGREDIENTS = "REMOVE_INGREDIENTS"
export const SET_INGREDIENTS = "SET_INGREDIENTS"
export const FETCH_INGREDIENTS_ERROR = "FETCH_INGREDIENTS_ERROR"

export const PURCHASE_BURGER_SUCCESS = "PURCHASE_BURGER_SUCCESS"
export const PURCHASE_BURGER_FAIL ="PURCHASE_BURGER_FAIL"
export const PURCHASE_BURGER_START ="PURCHASE_BURGER_START" //! sets loading to true
export const PURCHASE_INIT ="PURCHASE_INIT" //! will dispatch on pressing order

export const FETCH_ORDER_SUCCESS = "FETCH_ORDER_SUCCESS"
export const FETCH_ORDER_FAIL ="FETCH_ORDER_FAIL"
export const FETCH_ORDER_START ="FETCH_ORDER_START" //! sets loading to true
export const FETCH_ORDER_INIT ="FETCH_ORDER_INIT" //! sets loading to true

export const AUTH_START = "AUTH_START"
export const AUTH_SUCCESS = "AUTH_SUCCESS"
export const AUTH_FAIL = "AUTH_FAIL"










